import React, { useContext } from 'react';
import { useEffect } from 'react';
import { ToolbarContext } from '../../contexts/toolbar-context';
import {  FileInput, FileInputType } from '../../components/file-input';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary, Card, CardContent, CardHeader, Checkbox,
    FormControlLabel,
    Switch,
    TextField,
    Tooltip
} from '@mui/material';
import {CurrencySelect} from "../../components/MaterialSelects/CurrencySelect";
import {ProposalOptionSelect} from "../../components/MaterialSelects/ProposalOptionSelect";
import {NumberField} from "../../components/number-input";
import WaitSpinner from "../../components/wait-spinner";
import {UserSelect} from "../../components/MaterialSelects/UserSelect";
import NumberFormat from 'react-number-format';

// eslint-disable-next-line react/display-name
export function SalesTeamForm({diaForm,readOnly}) {
    const {values,errors,handleSubmit,onChange,isDirty,status} = diaForm;
    const id = values.id;
    const isNew = id === 'new';
    const loading = false;// TODO: fix this
    const toolbarContext = useContext(ToolbarContext);
    const doSave = handleSubmit;
    const baseUrl = '/settings/sales-teams/';
    const field = {
        onChange: onChange,
        loading: loading,
        disabled:readOnly,
    };
    useEffect(() => {
        let buttons = [{
            type: 'button',
            icon: 'save',
            tooltip: 'Save',
            callback: doSave,
            label: 'Save',
            style: 'primary',
            disabled: !isDirty||readOnly
        }];
        if(readOnly) { buttons = []; }
        toolbarContext.setSecondary({
                title: (!isNew ? '' + values.name : 'New Sales Team'),
                secondary: buttons,
                secondaryUrl:id,
                primaryUrl: baseUrl

            });
    }, [doSave, id, isDirty, isNew, status, values.name]);
    const spinner = (diaForm.status != 'ready' ||id!=values.id)? <WaitSpinner variant="overlay" />:null;
    return (
        <Accordion defaultExpanded={true}>
            {spinner}
            <AccordionSummary>Sales Team</AccordionSummary>
            <AccordionDetails className="grid12">
                <TextField className="grid12-span" label="Name" name="name"{...field} value={values.name} error={!!errors?.name}/>
                <TextField className="grid12-3" label="Campaign Prefix" name="prefix" {...field} value={values.prefix} error={!!errors?.prefix}/>
                <UserSelect className="grid12-3" label="Manager" name="manager" {...field} value={values.manager} error={!!errors?.manager}/>
                <FileInput className="grid12-3" label="Upload Logo" maxImageSize={900} multiple={false} name="logos" fileType="LG" showPreview={true} type={FileInputType.Image}
                           value={values.logos} {...field} />
                <TextField className="grid12-span" label="Document Footer" name="document_footer" {...field} value={values.document_footer??''} error={errors?.document_footer}/>
                <TextField className="grid12-span" label="Contact Email" name="contact_email" {...field} value={values.contact_email??''} error={!!errors?.contact_email}/>
                <TextField className="grid12-span" label="Website" type="url" name="url" {...field} value={values.url??''} error={!!errors?.url}/>
                <CurrencySelect className="grid12-3" label="Default Currency" name="defaultCurrency" {...field} value={values.defaultCurrency} error={!!errors?.defaultCurrency}/>
                <CurrencySelect className="grid12-3" label="Reporting Currency" name="reportingCurrency" {...field} value={values.reportingCurrency} error={!!errors?.defaultCurrency} allowBlank={true}/>
                <FormControlLabel className="grid12-3" control={
                    <Checkbox name="has_tax" {...field} checked={values.has_tax} />}
                label="Has Sales Tax"/>
                {values.has_tax &&
                    <NumberFormat
        name="tax_amount"
        value={values.tax_amount}
        readOnly={readOnly}
        thousandSeparator=","
        size={5}
        suffix='%'
        decimalScale={2}
        allowNegative={false}
        onFocus={(evt)=>evt.target.select()}
        onChange={(evt)=>{
            // convert into float
            const newEvt = {target:{name:evt.target.name,value:parseFloat(evt.target.value)}};
            console.log('OCC',newEvt);
            field.onChange(newEvt);
        }}
        placeholder={''}
    />
                }
                <FormControlLabel className="grid12-3" control={
                    <Checkbox name="include_dashboard_all" disabled={readOnly} {...field} checked={values.include_dashboard_all} />
                } label="Include in dashboard 'All Sales Teams'" />
                <FormControlLabel className="grid12-3" control={
                    <Checkbox name="include_dashboard_core" disabled={readOnly} {...field} checked={values.include_dashboard_core} />
                } label="Include in dashboard 'Core Sales Teams'" />
                <FormControlLabel className="grid12-3 grid12-clear" control={
                    <Tooltip title="Displays discount% as commission when client type is set to commission">
                        <Checkbox name="supports_commission" disabled={readOnly} {...field} checked={values.supports_commission} />
                    </Tooltip>
                } label="Supports Commission"/>
                <FormControlLabel className="grid12-3 grid12-clear" control={
                    <Tooltip title="Support for Regional AM Allocation">
                        <Checkbox name="supports_regional_am_allocation" disabled={readOnly} {...field} checked={values.supports_regional_am_allocation} />
                    </Tooltip>
                } label="Supports AM"/>
                {values.supports_commission != '' &&
                    <Card className="grid12-span">
                        <CardHeader title="Commission"/>
                        <CardContent className="grid12">
                        <Tooltip
                            title="Notes that appear under financial summary in the portfolio for commission campaigns">
                            <TextField className="grid12-span" label="Commission Financial Notes" name="commission_financial_notes"
                                       multiline={true} {...field} value={values.commission_financial_notes??''}
                                       error={!!errors?.commission_financial_notes}/>
                        </Tooltip>
                        <TextField className="grid12-span" label="Disclaimer (commission)" name="disclaimer_commission"
                                   multiline={true} {...field} value={values.disclaimer_commission??''}
                                   error={!!errors?.disclaimer_commission}/>
                        </CardContent>
                    </Card>
                }
                <Tooltip className="grid12-span" title="Tweaks to the proposal layout for campaign">
                    <ProposalOptionSelect {...field} multiple={true} name="proposalOptions" value={values.proposalOptions} errors={!!errors?.proposalOptions} label="Proposal Options"/>
                </Tooltip>
                <Tooltip className="grid12-3" title="This is the next ID used for this sales team, do NOT set this to a lower number than an existing job reference">
                    <NumberField label="Current job Reference" name="current_job_number" {...field} value={values.current_job_number} error={!!errors?.current_job_number}/>
                </Tooltip>
            </AccordionDetails>
            <Accordion defaultExpanded={true}>
                <AccordionSummary>Address Override</AccordionSummary>
                <AccordionDetails className="grid12">
            <TextField className="grid12-span" label="Street Address" type="street_address" name="street_address" {...field} value={values.street_address} error={!!errors?.street_address}
            placeholder="THE BASEMENT, 15 DUNCAN TERRACE"/>
            <TextField className="grid12-4" label="City" type="city" name="city" {...field} value={values.city} error={!!errors?.city} placeholder="LONDON"/>
            <TextField className="grid12-4" label="Postal Code" type="postal_code" name="postal_code" {...field} value={values.postal_code} error={!!errors?.postal_code}
            placeholder="N1 8BZ"/>
            <TextField className="grid12-4" label="Tel" type="tel" name="tel" {...field} value={values.tel} error={!!errors?.tel} placeholder="+44 (0) 207 916 5483"/>
                </AccordionDetails>
            </Accordion>
        </Accordion>
    );
}